export default [
  {
    id: "001",
    title: "概要",
    children: [
      {
        id: "001001",
        title: "得理科技简介",
        content: `
深圳得理科技有限公司成立于2018年，是一家由国内顶级法律团队和 AI 团队联合发起的法律科技公司，并于2019年联手中科院深圳先进院成立法律人工智能实验室，专注法律行业AI模型算法研究。

以自研的得理法律大模型为基础，得理科技还研发了得理律助和得理法搜两条主要产品线，以小理AI和小理智能体为核心组件，为法律人、企业及个人提供一揽子法律+AI解决方案。
        `,
      },
    ],
  },
  {
    id: "002",
    title: "得理法搜",
    children: [
      {
        id: "002001",
        title: "得理法搜简介",
        content: `
得理法搜，是由深圳得理科技有限公司联合中科院先进院-得理法律人工智能实验室历经6年潜心研发推出的法律AI产品。

内含5亿+法律数据，包括1.6亿+裁判文书、300万+法律法规、500万+法律知识等海量数据。 在法律大模型+法律大数据+DeepSeek的加持下，得理法搜可进行专业的法律检索，同时支持日常法律咨询、法律研究、案情分析、法律文书的生成、合同生成、合同审查、律师智能推荐等功能，满足用户各个场景的使用。

法律难题，就找得理法搜。
        `,
      },
      {
        id: "002002",
        title: "得理法搜有哪些版本，分别适合谁使用？",
        content: `
得理法搜分为企业版和专业版。

企业版更适用于企业及企业法务使用，其中有比如合规AI、政策AI等专注于企业场景的功能。

如果是企业或者企业法务，更推荐企业版，您如果是其他法律从业人员或个人，更推荐专业版。

这是具体两个版本的功能清单对比（SVIP和VIP均属于专业版）。

<table class="custom-table">
  <tr bgcolor="#92AADE">
    <td colspan="4" style="text-align:center;font-weight:bold;">得理法搜功能清单</td>
  </tr>
  <tr bgcolor="#D9E1F2">
    <td>会员类型/功能对比</td>
    <td>企业版</td>
    <td>SVIP</td>
    <td>VIP</td>
  </tr>
  <tr>
    <td>合规AI</td>
    <td>合规AI</td>
    <td>/</td>
    <td>/</td>
  </tr>
  <tr>
    <td>政策AI</td>
    <td>政策AI</td>
    <td>/</td>
    <td>/</td>
  </tr>
  <tr>
    <td>文书AI</td>
    <td>文书AI</td>
    <td>/</td>
    <td>/</td>
  </tr>
  <tr>
    <td>律师函</td>
    <td>享7.8折</td>
    <td>原价</td>
    <td>原价</td>
  </tr>
  <tr>
    <td rowspan="2">智能合同</td>
    <td>合同生成</td>
    <td>合同生成</td>
    <td>/</td>
  </tr>
  <tr>
    <td>合同审查</td>
    <td>合同审查</td>
    <td>/</td>
  </tr>
  <tr>
    <td rowspan="3">专业模型</td>
    <td>破产</td>
    <td>破产</td>
    <td>/</td>
  </tr>
  <tr>
    <td>地产工程（即将上线）</td>
    <td>地产工程（即将上线）</td>
    <td>/</td>
  </tr>
  <tr>
    <td>知识产权（即将上线）</td>
    <td>知识产权（即将上线）</td>
    <td>/</td>
  </tr>
  <tr>
    <td rowspan="3">专业法律检索</td>
    <td>智能语义检索</td>
    <td>智能语义检索</td>
    <td>智能语义检索</td>
  </tr>
  <tr>
    <td>关键词检索</td>
    <td>关键词检索</td>
    <td>关键词检索</td>
  </tr>
  <tr>
    <td>长文本检索</td>
    <td>长文本检索</td>
    <td>长文本检索</td>
  </tr>
  <tr>
    <td rowspan="4">AI阅读裁判文书</td>
    <td>智能摘要</td>
    <td>智能摘要</td>
    <td>智能摘要</td>
  </tr>
  <tr>
    <td>裁判要点</td>
    <td>裁判要点</td>
    <td>裁判要点</td>
  </tr>
  <tr>
    <td>案例时间轴</td>
    <td>案例时间轴</td>
    <td>案例时间轴</td>
  </tr>
  <tr>
    <td>类案检索报告</td>
    <td>类案检索报告</td>
    <td>类案检索报告</td>
  </tr>
  <tr>
    <td rowspan="4">法律研究</td>
    <td>争议焦点分析</td>
    <td>争议焦点分析</td>
    <td>争议焦点分析</td>
  </tr>
   <tr>
    <td>案情分析</td>
    <td>案情分析</td>
    <td>案情分析</td>
  </tr>
  <tr>
    <td>法律制度分析</td>
    <td>法律制度分析</td>
    <td>法律制度分析</td>
  </tr>
  <tr>
    <td>法律术语分析</td>
    <td>法律术语分析</td>
    <td>法律术语分析</td>
  </tr>
  <tr>
    <td rowspan="2">AI检索</td>
    <td>找类案</td>
    <td>找类案</td>
    <td>找类案</td>
  </tr>
  <tr>
    <td>找法规</td>
    <td>找法规</td>
    <td>找法规</td>
  </tr>
  <tr>
    <td rowspan="2">法律文书</td>
    <td>要素文书</td>
    <td>要素文书</td>
    <td>要素文书</td>
  </tr>
  <tr>
    <td>传统文书</td>
    <td>传统文书</td>
    <td>传统文书</td>
  </tr>
  <tr>
    <td rowspan="4">文本分析</td>
    <td>案件分析</td>
    <td>案件分析</td>
    <td>案件分析</td>
  </tr>
  <tr>
    <td>证据分析</td>
    <td>证据分析</td>
    <td>证据分析</td>
  </tr>
  <tr>
    <td>合同分析</td>
    <td>合同分析</td>
    <td>合同分析</td>
  </tr>
  <tr>
    <td>资料解读</td>
    <td>资料解读</td>
    <td>资料解读</td>
  </tr>
  <tr>
    <td>智能数字名片</td>
    <td>智能数字名片</td>
    <td>智能数字名片</td>
    <td>智能数字名片</td>
  </tr>
  <tr>
    <td rowspan="2">AI+律师法律咨询</td>
    <td>AI法律咨询</td>
    <td>AI法律咨询</td>
    <td>AI法律咨询</td>
  </tr>
  <tr>
    <td>问律师</td>
    <td>问律师</td>
    <td>问律师</td>
  </tr>
  <tr>
    <td rowspan="4">法律资讯推荐</td>
    <td>新法速递</td>
    <td>新法速递</td>
    <td>新法速递</td>
  </tr>
  <tr>
    <td>法律观点</td>
    <td>法律观点</td>
    <td>法律观点</td>
  </tr>
  <tr>
    <td>全国商机</td>
    <td>全国商机</td>
    <td>全国商机</td>
  </tr>
  <tr>
    <td>法讯订阅</td>
    <td>法讯订阅</td>
    <td>法讯订阅</td>
  </tr>
  <tr>
    <td>律师入驻</td>
    <td>律师入驻</td>
    <td>律师入驻</td>
    <td>律师入驻</td>
  </tr>
</table>

        `,
      },
      {
        id: "002003",
        title: "得理法搜有哪几种产品形态？",
        content: `
得理法搜有三种产品形态：网页版、手机App、微信小程序，用户可以通过任何一种方式随时随地访问得理法搜。
        `,
      },
      {
        id: "002004",
        title: "得理法搜有哪些核心优势？",
        content: `
<h3>1、全域法律数据</h3>
<p>汇集5亿+全量法律数据，并集成知识产权和地产工程两大专业库。数据实时更新，一次检索，多维呈现案例、法规、观点、法讯等数据。</p>
<h3>2、全域法律应用</h3>
<p>全面覆盖各类法律场景，同时支持日常法律咨询、法律研究辅助、案情分析预测、智能法律文书、智能合同、律师智能推荐等功能，满足用户各个场景的使用。 </p>
<h3>3、专有模型部署</h3>
<p>法律大模型+法律大数据+DeepSeek，集通用能力与法律模型能力于一体，为用户提供全方位支持，得理法律大模型也是首批通过国家网信办备案的生成式算法之一。 </p>
        `,
      },
      {
        id: "002005",
        title: "得理法搜亮点功能操作指引?",
        content: `
法律研究：智能体加持深度法律分析，为你拆解难题、高效出成果，轻松搞定专业研究

<video controls poster="https://delicdn.delilegal.com/dls/81828c52f84f97d26b4dcff883cdd8aa/81828c52f84f97d26b4dcff883cdd8aa.png" controlslist="noplaybackrate nodownload"><source src=" https://media.delilegal.com/video/data/6abb72b0.mp4" type="video/mp4" /></video>


AI检索：法律大模型与法律大数据深度结合，实现法律检索从“语义检索”到“对话式检索”

<video controls poster="https://delicdn.delilegal.com/dls/e3a28493372de143b1e05ab22f51bae9/e3a28493372de143b1e05ab22f51bae9.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/data/6ab2f632.mp4" type="video/mp4" /></video>

合同生成：将模糊的合同生成动作透明化，确保生成的合同兼具专业性与个性化

<video controls poster="https://delicdn.delilegal.com/dls/01cee153b8333e54c3665be6a073b603/01cee153b8333e54c3665be6a073b603.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/data/14e606db.mp4" type="video/mp4" /></video>

合同审查：总体审查与条款逐条审查结合，自定义审查与系统配置规则审查结合，精准识别合同风险，一键完成修订

<video controls poster="https://delicdn.delilegal.com/dls/fa2621c65de1f7a3070017d48f82d732/fa2621c65de1f7a3070017d48f82d732.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/data/414d59e0.mp4" type="video/mp4" /></video>


传统文书：智能生成+精准转换，完成标准与灵活兼备的诉讼文书与非诉讼文书

<video controls poster="https://delicdn.delilegal.com/dls/86baf42b2190ce9673b103368b25668a/86baf42b2190ce9673b103368b25668a.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/data/1a80564a.mp4" type="video/mp4" /></video>

要素文书：涵盖民间借贷、劳动争议、离婚、金融等67类案由的要素式文书的生成转换，满足最高院最新格式要求，告别手填表格。

<video controls poster="https://delicdn.delilegal.com/dls/f944bba10e8aa78e1f43bf847ab0cf22/f944bba10e8aa78e1f43bf847ab0cf22.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/data/d19d350b.mp4" type="video/mp4" /></video>

文本分析：AI智能分析各类法律文件，制定更好的诉讼策略，更快的解读合同协议、法规政策等文件

<video controls poster="https://delicdn.delilegal.com/dls/156b873988efb717c161fc2d7e893e20/156b873988efb717c161fc2d7e893e20.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/data/764b3bf3.mp4" type="video/mp4" /></video>
        `,
      },
      {
        id: "002006",
        title: "在得理法搜-小理AI上咨询律师收费吗？",
        content: `
咨询律师是免费的，得理科技希望搭建一个”AI+律师“的平台，帮助用户找到合适专业的律师，平台不会向律师和用户收取任何费用，具体的案件代理费用由双方协商确定。
        `,
      },
      {
        id: "002007",
        title: "在得理法搜-小理AI上咨询律师，但是长时间没有收到回复怎么办？",
        content: `
如果咨询的问题长时间没有回复，可以检查一下提的法律问题是否是真实有效？内容是否表达清晰？可修改完善后重新发起咨询。
        `,
      },
      {
        id: "002008",
        title: "得理法搜如何付费使用？",
        content: `
得理法搜按照付费订阅制提供服务，需要付费才可以使用完整功能，目前支持3年、1年、连续包月、1个月三种购买方式，用户在Web、App、小程序端均可从“我的”->“立即续费”进行付费购买。
        `,
      },
    ],
  },
  {
    id: "003",
    title: "得理律助",
    children: [
      {
        id: "003001",
        title: "得理律助简介",
        content: `
专为律师打造的智能助手

得理律助，由深圳得理科技有限公司联合中科院先进院-得理法律人工智能实验室历经8年潜心研发推出的信息化、数字化、智能化三位一体的法律科技平台，专为律师量身定制，以尖端科技驱动行业变革，助力律师低成本、高效率实现智能化转型。

通过案源广场、数字名片、内部市场、商机推送等功能，解决律师“拓案难”的问题；通过得理法搜和小理AI，解决律师在法律检索、法律研究、文书撰写等方面“任务繁多，难提效”的问题；通过客户、项目、任务、计时管理等功能，解决律师“协同难”的问题；通过小理智能体、客户价值可视化等方式，解决律师“服务难”的问题。
        `,
      },
      {
        id: "003002",
        title: "谁适合使用得理律助？",
        content: `
得理律助是专为律师打造的智能助手，分为个人版、团队版和机构版三个版本，分别适用于个人律师、团队和律所机构使用。

个人律师可使用常用的客户、合同、项目、任务、法搜、小理智能体、小理AI等功能外，也可以通过认证成为得理律助的入驻律师，获取从小理AI进行法律咨询的客户案源，拓展其案源渠道。

团队版和机构版都适合多人协同的组织使用，机构版更适合流程化管理的律所使用。

<table class="custom-table">
  <tr bgcolor="#B4C7E6">
    <td colspan="5" style="text-align:center;font-weight:bold;">得理律助产品及功能</td>
  </tr>
  <tr bgcolor="#DAE2F5">
    <td>版本</td>
    <td>会员权益</td>
    <td>个人版</td>
    <td>团队版</td>
    <td>机构版</td>
  </tr>
  <tr>
    <td rowspan="45">功能</td>
    <td rowspan="4">案源拓展</td>
    <td>/</td>
    <td>/</td>
    <td>内部市场</td>
  </tr>
  <tr>
    <td>数字名片</td>
    <td>数字名片</td>
    <td>数字名片</td>
  </tr>
  <tr>
    <td>案源广场</td>
    <td>案源广场</td>
    <td>案源广场</td>
  </tr>
  <tr>
    <td>商机推送</td>
    <td>商机推送</td>
    <td>商机推送</td>
  </tr>
  <tr>
    <td rowspan="10">智慧办公/办公协同</td>
    <td>/</td>
    <td>/</td>
    <td>利冲检查</td>
  </tr>
  <tr>
    <td>/</td>
    <td>/</td>
    <td>智慧印章</td>
  </tr>
  <tr>
    <td>/</td>
    <td>/</td>
    <td>开票流程</td>
  </tr>
  <tr>
    <td>/</td>
    <td>/</td>
    <td>指尖审批</td>
  </tr>
  <tr>
    <td>客户管理</td>
    <td>客户管理</td>
    <td>客户管理</td>
  </tr>
  <tr>
    <td>合同管理</td>
    <td>合同管理</td>
    <td>合同管理</td>
  </tr>
  <tr>
    <td>项目跟踪</td>
    <td>项目跟踪</td>
    <td>项目跟踪</td>
  </tr>
  <tr>
    <td>时间管理</td>
    <td>时间管理</td>
    <td>时间管理</td>
  </tr>
  <tr>
    <td>任务分发</td>
    <td>任务分发</td>
    <td>任务分发</td>
  </tr>
  <tr>
    <td>数据统计</td>
    <td>数据统计</td>
    <td>数据统计</td>
  </tr>
  <tr>
    <td rowspan="3">知识管理</td>
    <td>/</td>
    <td>/</td>
    <td>知识库</td>
  </tr>
  <tr>
    <td>云盘DOC</td>
    <td>云盘DOC</td>
    <td>云盘DOC</td>
  </tr>
  <tr>
    <td>文档协作</td>
    <td>文档协作</td>
    <td>文档协作</td>
  </tr>
  <tr>
    <td rowspan="2">小理智能体</td>
    <td>名片智能体</td>
    <td>名片智能体</td>
    <td>名片智能体</td>
  </tr>
  <tr>
    <td>客服智能体</td>
    <td>客服智能体</td>
    <td>客服智能体</td>
  </tr>
  <tr>
    <td rowspan="2">智能合同</td>
    <td>合同生成</td>
    <td>合同生成</td>
    <td>合同生成</td>
  </tr>
  <tr>
    <td>合同审查</td>
    <td>合同审查</td>
    <td>合同审查</td>
  </tr>
  <tr>
    <td rowspan="3">专业法律检索</td>
    <td>智能语义检索</td>
    <td>智能语义检索</td>
    <td>智能语义检索</td>
  </tr>
   <tr>
    <td>关键词检索</td>
    <td>关键词检索</td>
    <td>关键词检索</td>
  </tr>
  <tr>
    <td>长文本检索</td>
    <td>长文本检索</td>
    <td>长文本检索</td>
  </tr>
  <tr>
    <td rowspan="4">AI阅读裁判文书</td>
    <td>智能摘要</td>
    <td>智能摘要</td>
    <td>智能摘要</td>
  </tr>
  <tr>
    <td>裁判要点</td>
    <td>裁判要点</td>
    <td>裁判要点</td>
  </tr>
  <tr>
    <td>案例时间轴</td>
    <td>案例时间轴</td>
    <td>案例时间轴</td>
  </tr>
  <tr>
    <td>类案检索报告</td>
    <td>类案检索报告</td>
    <td>类案检索报告</td>
  </tr>
  <tr>
    <td rowspan="4">法律研究</td>
    <td>争议焦点分析</td>
    <td>争议焦点分析</td>
    <td>争议焦点分析</td>
  </tr>
   <tr>
    <td>案情分析</td>
    <td>案情分析</td>
    <td>案情分析</td>
  </tr>
  <tr>
    <td>法律制度分析</td>
    <td>法律制度分析</td>
    <td>法律制度分析</td>
  </tr>
  <tr>
    <td>法律术语分析</td>
    <td>法律术语分析</td>
    <td>法律术语分析</td>
  </tr>
  <tr>
    <td rowspan="2">AI检索</td>
    <td>找类案</td>
    <td>找类案</td>
    <td>找类案</td>
  </tr>
  <tr>
    <td>找法规</td>
    <td>找法规</td>
    <td>找法规</td>
  </tr>
  <tr>
    <td rowspan="2">法律文书</td>
    <td>要素文书</td>
    <td>要素文书</td>
    <td>要素文书</td>
  </tr>
  <tr>
    <td>传统文书</td>
    <td>传统文书</td>
    <td>传统文书</td>
  </tr>
  <tr>
    <td rowspan="4">文本分析</td>
    <td>案件分析</td>
    <td>案件分析</td>
    <td>案件分析</td>
  </tr>
  <tr>
    <td>证据分析</td>
    <td>证据分析</td>
    <td>证据分析</td>
  </tr>
  <tr>
    <td>合同分析</td>
    <td>合同分析</td>
    <td>合同分析</td>
  </tr>
  <tr>
    <td>资料解读</td>
    <td>资料解读</td>
    <td>资料解读</td>
  </tr>
  <tr>
    <td rowspan="4">法律资讯推荐</td>
    <td>新法速递</td>
    <td>新法速递</td>
    <td>新法速递</td>
  </tr>
  <tr>
    <td>法律观点</td>
    <td>法律观点</td>
    <td>法律观点</td>
  </tr>
  <tr>
    <td>全国商机</td>
    <td>全国商机</td>
    <td>全国商机</td>
  </tr>
  <tr>
    <td>法讯订阅</td>
    <td>法讯订阅</td>
    <td>法讯订阅</td>
  </tr>
  <tr>
    <td rowspan="1">律师入驻</td>
    <td>律师入驻</td>
    <td>律师入驻</td>
    <td>律师入驻</td>
  </tr>
</table>

        `,
      },
      {
        id: "003003",
        title: "得理律助有哪几种产品形态？",
        content: `
可以通过网页版、手机App使用得理律助

网页端网址:<a style="color:#4493f8" href="https://dls.delilegal.com">https://dls.delilegal.com</a>

App版下载：应用市场搜索“得理律助”或手机扫码下载

![image](https://delicdn.delilegal.com/dls/584844cd6ec9ffd30422405828f072b8/584844cd6ec9ffd30422405828f072b8.png)
        `,
      },
      {
        id: "003004",
        title: "得理律助有哪些核心优势？",
        content: `
①专为律师/律所全场景协同办公设计，通过法律大数据+法律大模型，一站式解决律师拓客难、办案难、服务难、协同难四大痛点，为律师提供从案源获取到案件办理、客户服务的全场景数智化解决方案。

②联合中科院深圳先进院-得理联合实验室开发，拥有18项发明专利和22项软件著作权，得理法律大模型也是首批通过国家网信办备案的生成式算法之一。

③获评“高交会优秀产品”、“最受上海律师欢迎的法律科技产品”等多项大奖，获得行业广泛认可。
        `,
      },
      {
        id: "003005",
        title: "得理律助亮点功能操作指引",
        content: `
案源拓展：用大数据和AI技术助力律师精准获客

<video width="360" height="640" controls poster="https://delicdn.delilegal.com/dls/18a327f9fecf0e820d3b77d0802cc894/18a327f9fecf0e820d3b77d0802cc894.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/dls/3607f842.mp4" type="video/mp4" /></video>


案件管理：给每位律师配备的智慧秘书，通过案件管理工作流，帮助律师更好地管理客户和在办案件，提升工作效率

<video width="360" height="640" controls poster="https://delicdn.delilegal.com/dls/b2ac713553aafe71f8ca1e920582c01c/b2ac713553aafe71f8ca1e920582c01c.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/dls/fc9886f6.mp4" type="video/mp4" /></video>

知识管理：专为律师打造的高效、便捷、安全的知识管理解决方案

<video width="360" height="640" controls poster="https://delicdn.delilegal.com/dls/bc2c279b2c2bc07b9c50c0e608331690/bc2c279b2c2bc07b9c50c0e608331690.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/dls/9f65493e.mp4" type="video/mp4" /></video>

小理智能体：辅助律师完成营销拓客、客户服务、服务报告等工作，让律师专注复杂法律事务解决

<video width="360" height="640" controls poster="https://delicdn.delilegal.com/dls/2c3363e26a8c57194ec027518c830bfd/2c3363e26a8c57194ec027518c830bfd.png" controlslist="noplaybackrate nodownload"><source src="https://media.delilegal.com/video/dls/f7041902.mp4" type="video/mp4" /></video>
        `,
      },
      {
        id: "003006",
        title: "购买得理法搜的用户如何升级成为得理律助用户？",
        content: `
在得理法搜付费后又希望升级到得理律助的用户，支付完对应费用后得理法搜剩余的有效天数会折算到得理律助中。
        `,
      },
      {
        id: "003007",
        title: "邀请成员加入得理律助时显示失败怎么办？",
        content: `
１、提示已失效：邀请链接有效时间为24小时，被邀请成员打开链接提示已失效，联系团队／律所管理员重新生成邀请链接即可。

２、提示席位已满：联系团队／律所管理员购买新的席位，重新生成邀请链接即可。
        `,
      },
      {
        id: "003008",
        title: "团队组织如何切换？",
        content: `
得理律助支持同一用户可以隶属于多个个人、团队或机构，登录成功后，在左上角可进行组织切换，可在个人、所属团队和所属机构之前自由切换，并可创建新的团队和机构。
        `,
      },
      {
        id: "003009",
        title: "开始使用前需要进行怎样的初始化工作？",
        content: `
系统管理员在正式使用前应进行以下初始化设置：

1.  流程审批，设置各个环节的审批人或待办接收人

2.  文件编号，设置合同、盖章的业务流水号规则，包含动态的年份、流水号及文件类型等。如“（2023）深律诉字第0001号”，可以通过“（{年份}）深律诉字第{合同编号}号”来实现。

3.  历史合同数据导入，联系得理企微客服，咨询数据导入（包括历史的合同信息、项目及文件信息）
        `,
      },
      {
        id: "003010",
        title: "个人版已盖章合同和合同创建的区别？",
        content: `
已盖章合同指上线得理律助系统之前的已经盖章的生效中的合同历史数据。合同创建指起草一个合同草稿。
        `,
      },
      {
        id: "003011",
        title: "个人版合同管理与机构版有何差异？",
        content: `
个人版合同管理没有流程驱动，仅上传已盖章合同即视为生效并可管理其履约过程，且无利冲、开票、审批等流程环节。
        `,
      },
      {
        id: "003012",
        title: "律师如何通过得理律助获取案源？",
        content: `
可以通过两个方式在得理律助获取案源，第一个方式是法讯中的商机版块，得理科技每天会从全国各地的招投标信息中采集和梳理法律服务类的招标信息供参考。第二个方式是得理律助首页工作台中的案源版块，可以实时显示小理AI平台用户发起的法律咨询问题，律师可通过抢单回复，以获取与客户沟通的机会。（需注意的是只有通过认证入驻得理律助的律师才可以查看案源）。
        `,
      },
      {
        id: "003013",
        title: "律师如何进行认证以便查看案源？",
        content: `
得理律助中的案源只有认证过的律师才可以查看，可以在"工作台"->"案源"处的“消息”->“律师认证”，完善律师的详细信息，得理后台审核通过后，即可查看案源。
        `,
      },
      {
        id: "003014",
        title: "如何为他人创建日程？",
        content: `
为他人创建日程的场景有助理为主办律师创建待办任务，或律所合伙人给下属员工指派任务，也可用于人力资源给面试者创建面试任务等。

通过“新建任务”->”项目任务“->指定负责人的形式可以为其它创建任务及日程。创建的任务会在"工作台"->"重要提醒"处进行提示。
        `,
      },
      {
        id: "003015",
        title: "个人任务、合同任务、项目任务分别有什么差异？",
        content: `
创建任务时，如果选择是“项目任务”，且选择的项目有关联合同，则该任务的计时也会同步到该合同中。在按合同进行计时统计时，该任务所有的计时会纳入该合同。
        `,
      },
      {
        id: "003016",
        title: "团队版如何管理团队成员？",
        content: `
团队版的管理员（通常为创建该团队的用户），可以通过“管理”->“成员管理”，添加成员（生成邀请链接发给团队成员，由其自主注册加入团队）。也可以点击成员“…”在弹出菜单中“删除该成员”的方式移除成员，以便在人员变动的情况下管理有效席位。
        `,
      },
      {
        id: "003017",
        title: "购买团队版后如何进行席位的扩容？",
        content: `
随着团队的人数增多，若原有席位数不够，管理员可以点击“购买席位”可进行席位扩容。
        `,
      },
      {
        id: "003018",
        title: "团队成员可以看到其它成员的日程信息吗？",
        content: `
管理员可以通过开关配置日程权限。日程权限默认是个人查看自已的日程，但可以通过“管理”->“应用设置”，指定机构所有人可查看选项，团队成员可以查看所有其它人的日程信息。
        `,
      },
      {
        id: "003019",
        title: "团队成员可以查看其它成员的日程信息吗？",
        content: `
管理员可以通过开关配置日程权限。日程权限默认是个人查看自已的日程，但可以通过“管理”->“应用设置”，指定机构所有人可查看选项，团队成员可以查看所有其它人的日程信息。
        `,
      },
      {
        id: "003020",
        title: "签约客户和线索客户的区别？",
        content: `
签约客户顾名思义是有签过正式合同的客户，而线索客户只是一个商机，需要进一步跟进。团队和机构的成员都可以添加线索客户，线索客户的信息是公开的，全员都可以看到和跟进。
        `,
      },
      {
        id: "003021",
        title: "线索客户如何转为签约客户？",
        content: `
线索客户在线下跟进明确要签合同时，无需新建客户，可以将线索客户转为签约客户：线索客户列表->客户状态修改为签约客户，在弹出的客户信息处完善保存，即可转为签约客户。
        `,
      },
      {
        id: "003022",
        title: "如何更好的团队协同？",
        content: `
团队协同包括：协同维护客户、协同处理流程事务、协同处理项目任务、日程协同等。

协同维护客户：客户从线索客户开始，每一次客户的跟进都可以填写跟进记录，以方便后续跟进人员了解对客户的完整服务链路。不论内部人员如何变动，服务轨迹始终留痕。这个工作是管理上的要求，需要律所机构或团队管理者对成员提出要求。

协同处理流程事务：合同全流程、盖章流程、开票流程是律所机构最常用的流程，机构版的流程可以依据组织架构对各个岗位的人员进行设置，以便流程自动将任务推送到待办的接收人处，真正实现闭环的管理，避免人为的工作遗漏造成的低效。

协同处理项目任务：通过项目式的管理，项目成员任务可以有效的组织和进度跟进，项目中的文档可以有效的协同在线编辑，文件动态项目成员可见。通过项目的协同，即便项目跨度时间长，项目成员人员交替，其管理过程的知识的沉淀始终在系统里。

协同日程任务：日程任务可以自已给自已增加（个人任务），也可以给其它人增加（项目任务），可用于上级与下级、同级、下级与上级之间的任务协同管理。
        `
      },
      {
        id: "003023",
        title: "机构版如何管理机构成员？",
        content: `
机构版有两种方式管理组织架构及成员：自主管理组织架构方式和基于钉钉的组织架构管理。可依据日常办公需要进行对应的管理。

自主管理组织架构方式：适用于以微信作为主要沟通交流平台的机构或团队。管理员新建机构或团队后，进入“管理”->“成员与部门”进行邀请和管理。

![image](https://delicdn.delilegal.com/dls/2f0c01672bd14aabaed6d978801e9e59/2f0c01672bd14aabaed6d978801e9e59.png)

基于钉钉的管理方式：基于钉钉的组织架构管理好处是，钉钉中在律所中新增的成员会由系统自动定时同步（凌晨一点）。适用于律所线下管理以钉钉为主，这样可和钉钉现有的业务办公进行有效的结合。

钉钉企业管理员用钉钉扫码开通“DLS律师数字化平台”应用，一旦开通应用，企业里的所有成员就可以使用钉钉扫码登录：

<p align="center">
<img src="https://delicdn.delilegal.com/dls/457bc9155b3357e509bc76fae7806154/457bc9155b3357e509bc76fae7806154.png" alt="image" style="zoom: 33%;" />
</p>
        `
      },
      {
        id: "003024",
        title: "如何管理角色和权限？",
        content: `
得理律助角色与权限主要分为4类：

1.  超级管理员 通常为律所主任、高级合伙人或高层领导，拥有最高权限，可以进行系统设置，并查看全部业务数据。

2.  普通管理员 通常为行政人力、秘书助理、IT技术人员，拥有系统设置权限，可设置流程、成员与部门等。

3.  业务主办 通常为各业务合伙人，拥有查看指定部门的全部业务数据权限。

4.  协办人员 通常为各业务中心的法务秘书或者业务办理者，拥有查看指定部门的合同数据权限以便开展归档、盖章、开票等事务。
        `
      },
      {
        id: "003025",
        title: "成员离职了工作如何交接？",
        content: `
得理律助针对成员离职或调岗的情况，可以将该成员发起的合同、盖章、开票等历史流程或审批中的流程中数据移交给指定的其他人。如果该成员还涉及在审批流中的环节待办人员，还应进入流程管理进行对应的设置。
        `
      },
      {
        id: "003026",
        title: "如何支付购买？",
        content: `
个人版可直接付费购买，团队或机构版的按使用人数进行席位购买，单个席位价格低于个人版，按照席位数阶梯价格不一样，详情咨询得理科技企业微信客服。
        `
      },
      {
        id: "003027",
        title: "合同流程的完整生命周期管理是怎样的？",
        content: `
得理律助使用全流程闭环管理的方式进行合同的管理，合同的全流程可依据律所职务的权责定制化设置各环节的申批人，流程由工作流引擎驱动，自动流转到各个环节。

![image](https://delicdn.delilegal.com/dls/3bfc48a2cc3bd92fea44070b72447d4f/3bfc48a2cc3bd92fea44070b72447d4f.png)
        `
      },
      {
        id: "003028",
        title: "合同如何作废？",
        content: `
合同作废操作可以合同正在审批中时，由审批人打回，或当合同在履约中时，由主办律师进行编辑，并设置合同为“已作废”状态。
        `
      },
      {
        id: "003029",
        title: "机构版已盖章合同和合同创建的区别？",
        content: `
已盖章合同指律所在上线得理律助系统之前的历史数据或律师转所时所带来的已经盖章的生效中的合同，因此无需再走利冲审查等合同的创建流程，直接上传就变为生效状态。合同创建也分为两类，一种是从无到有起草，一种是已经有草稿合同的模板（或第三方的合同），依据实际情况进行创建合同，并需走利冲审查等一系列流程。
        `
      },
      {
        id: "003030",
        title: "有几种发起合同创建的流程方式？",
        content: `
发起合同创建流程分两种情况：一种情况是从合同创建，起草合同后引入利冲审查。另一种情况是先发起利冲审查，审查通过无利冲后再进行合同创建。
        `
      },
      {
        id: "003031",
        title: "利冲审查后是否一定紧跟创建合同步骤？",
        content: `
不一定，比如在客户询价或录入客户潜在客户资料前，先仅仅进行利冲审查预查询，而不创建合同，如无利冲再和客户沟通确定签约后再进行合同创建。
        `
      },
      {
        id: "003032",
        title: "如何使用订卷模板？",
        content: `
合同履约结束时，通常要进行订卷操作，即按照一定的格式打印出订卷的目录或卷宗的边框封条，得理律助支持从订卷模板生成要打印的订卷文件，避免了手动再抄写合同编号、客户信息等操作。

“履约中”的合同，由主办律师在该合同详情页点击“编辑合同”，在合同附件处点击“从模板中生成”选取对应类型的订卷模板，打开生成的订卷附件，直接打印即可，也可以编辑后再打印。
        `
      },
      {
        id: "003033",
        title: "如何补充上传合同的附件？",
        content: `
在合同履约过程中有些补充协议或其它相关文件可以补充上传。“履约中”的合同，由主办律师在该合同详情页点击“编辑合同”，在合同附件处点击“上传附件”。
        `
      },
      {
        id: "003034",
        title: "律所主任如何通过得理律助了解律所实时数据情况？",
        content: `
为了方便律所主任了解律所的合同及客户服务情况，可通过“统计”功能查看律所实时数据统计情况：包括总览、签约客户Top5、客户数量趋势、合同金额趋势、服务时长统计、签约客户统计、客户分布情况等图表化的指标。
        `
      },
    ],
  },
  {
    id: "004",
    title: "智能名片+知识库帮助文档",
    children: [
      {
        id: "004001",
        title: "概览",
        content: `
在数字化转型浪潮中，传统的纸质名片正在被新一代的智能名片所取代。对于法律行业而言，智能名片不仅仅是联系方式的载体，更成为了展示专业能力、提供即时服务、精准获客的综合性数字化工具。智能名片通过技术创新，为律师事务所和执业律师带来全新的服务模式和商业价值。

<h2>传统名片的局限性与智能名片的突破</h2>

<h3>传统名片的困境</h3>

传统纸质名片受制于物理载体的限制，只能承载基础的联系信息，如姓名、职务、电话、邮箱等。对于律师这样需要展示丰富专业背景的职业而言，传统名片显得格外局促：

<span style="display: inline-block;text-indent:20px;">● 信息容量有限：无法展示教育背景、执业经历、专业领域、成功案例等关键信息</span>

<span style="display: inline-block;text-indent:20px;">● 更新成本高：信息变更需要重新印刷，成本高且时效性差</span>

<span style="display: inline-block;text-indent:20px;">● 传播效率低：依赖面对面交换，传播范围受限</span>

<span style="display: inline-block;text-indent:20px;">● 互动性缺失：缺乏即时沟通和深度交流的可能</span>

<h2>智能名片的技术优势</h2>

智能名片基于移动互联网和云计算技术，突破了传统名片的物理限制，实现了信息展示的立体化和互动化：

<span style="display: inline-block;text-indent:20px;">● 多维信息展示：通过富媒体内容，智能名片可以集成视频介绍、案例展示、资质证书、客户评价等多元化信息，全方位展现律师的</span>
<span style="display: inline-block;text-indent:32px;">职业能力和专业水准。</span>

<span style="display: inline-block;text-indent:20px;">● 实时信息更新：基于云端数据同步技术，律师可以随时更新个人信息、最新案例、法律观点等内容，确保客户获取的信息始终是最</span>
<span style="display: inline-block;text-indent:32px;">新的。</span>

<span style="display: inline-block;text-indent:20px;">● 无接触式传播：通过二维码、链接分享等方式，实现跨时空的信息传递，大幅提升传播效率。</span>

<span style="display: inline-block;text-indent:20px;">● 7×24小时智能客服：结合自定义的知识库和大语言模型技术，智能名片可以内置智能问答系统，为客户提供全天候的法律咨询服</span>
<span style="display: inline-block;text-indent:32px;">务。这一功能的技术实现包括：</span>

<span style="display: inline-block;text-indent:20px;">● 知识库：将律师的专业知识、案例经验、法律条文等结构化为知识库，为智能问答提供可靠的数据基础。</span>
        `,
      },
      {
        id: "004002",
        title: "智能名片创建",
        content:`
在微信小程序“得理法搜”，依次点击“我的”-“我的名片”。

![image](https://delicdn.delilegal.com/dls/db52d32abb7982c2c1f0da8904429bb5/db52d32abb7982c2c1f0da8904429bb5.png)

点击编辑名片：完善律师的个人详细信息，包括：基本信息、个人简介、律所简介、教育背景、荣誉头衔等，全面展示律师的个人形象。

提示：

1. 律师勾选打开开关“律师认证-获取案源支持”时，填写执业证号并上传执业证照片，平台将在小理 AI、深i企智能法律的“问律师”等多个渠道向用户推荐律师，为律师引流。

2. 可以通过 AI 智能生成或优化个人信息、律所简介。

3. 可以通过 AI 智能美化头像。
        `
      },
      {
        id: "004003",
        title: "知识库创建",
        content: `
智能名片的知识库支持两种类型：1.腾讯云智能体应用，2.得理律助知识库。

已有“得理律助”机构版账户的用户建议使用“得理律助知识库”管理知识和挂载知识库到智能名片上，否则请使用“腾讯云智能体应用”管理知识和大模型。

<h2>1.创建腾讯云智能体应用</h2>

网页上输入：<a style="color:#4493f8" href="https://cloud.tencent.com/product/tcadp?Is=sdk-topnav">https://cloud.tencent.com/product/tcadp?Is=sdk-topnav</a>  进入智能体开发平台，点击“产品体验”：

![image](https://delicdn.delilegal.com/dls/9383efd3a6782eeee7839bd061a18edd/9383efd3a6782eeee7839bd061a18edd.png)

<h3>注册和登录</h3>

浏览器地址栏中输入：<a style="color:#4493f8" href="https://cloud.tencent.com/product/tcadp">https://cloud.tencent.com/product/tcadp</a> ，点击“产品体验”，微信扫码注册登录到开发平台首页，并新建一个标准应用：

![image](https://delicdn.delilegal.com/dls/48f7b37d7141f1eea0540b5ae1fd73c1/48f7b37d7141f1eea0540b5ae1fd73c1.png)

<h3>上传知识</h3>

点击查看应用并切换到“知识管理”，导入一个或多个本地文件，也可以导入已发表的公众号文章网页：

![image](https://delicdn.delilegal.com/dls/95222e9055668fbcf71ffad9df07c444/95222e9055668fbcf71ffad9df07c444.png)

<h3>发布应用</h3>

点击右上角发布按钮，发布完成后即可从应用发布-服务状态中复制AppKey这个重要的密钥来调用知识库应用了：

![image](https://delicdn.delilegal.com/dls/e916416ac10c145eec66442eeaa79872/e916416ac10c145eec66442eeaa79872.png)

<h2>2.律助知识库管理</h2>

<h3>知识库管理</h3>

浏览器地址栏中输入：<a style="color:#4493f8" href="https://dls.delilegal.com ">https://dls.delilegal.com </a> 进入得理律助，切换到机构版，在左侧菜单栏选择“知识库”，进入知识库查看和管理页：

![image](https://delicdn.delilegal.com/dls/62e41a96c0046e1a507f9c25a5aafc83/62e41a96c0046e1a507f9c25a5aafc83.png)

<h3>知识发布</h3>

点击右上角“发布知识”：

![image](https://delicdn.delilegal.com/dls/67f88e4653d79f69515619ca08556096/67f88e4653d79f69515619ca08556096.png)

AppKey的生成：（如下图示）点击知识库首页右上角”我的发布”，点击左侧菜单“API管理”，如果没有显示
AppKey则点击“重新生成”，生成一个新的AppKey，如果已经有AppKey存在，则点击“复制”到剪贴板再发送到手机端，在“得理法搜”小程序端 -我的名片完成AppKey 的设置并挂载律助知识库。（说明：AppKey是用于用户权限鉴别的重要凭据，请不要泄露给第三人，可以不定期“重新生成”以使原来的 AppKey 失效来加强安全性）
![image](https://delicdn.delilegal.com/dls/997c18c07c1afb829b8068baa4556918/997c18c07c1afb829b8068baa4556918.png)
`
      },
      {
        id: "004004",
        title: "智能名片挂载知识库",
        content: `
在第二步创建名片中的“编辑名片”步骤过程中，勾选打开知识库开关，允许挂载自定义知识库，智能聊天时优先基于知识库回答，填写上个步骤中获取的appKey：

![image](https://delicdn.delilegal.com/dls/6d2ed7d91a96f48dce16a9e5d0208c2c/6d2ed7d91a96f48dce16a9e5d0208c2c.png)

可以对公开的知识库设置权限，比如有些个人机密信息的知识库可以选择不公开：

![image](https://delicdn.delilegal.com/dls/1686a15342895fa5b15ebc5063b0ee39/1686a15342895fa5b15ebc5063b0ee39.png)
`
      },
      {
        id: "004005",
        title: "分享名片",
        content: `
点击第二个步骤中我的名片信息上的“分享名片”按钮，发送到微信聊天、朋友圈等。

![image](https://delicdn.delilegal.com/dls/7a8c2423c5cf4372c91f41318e408568/7a8c2423c5cf4372c91f41318e408568.png)
`
      },
      {
        id: "004006",
        title: "客户咨询使用知识库回答",
        content: `
在律师忙时，可以将智能名片发给客户，向客户提供 7*24 小时的智能数字分身服务，减少了律师回答问题的工作量：

![image](https://delicdn.delilegal.com/dls/f2830461aaad783f2c1dd58a100b552a/f2830461aaad783f2c1dd58a100b552a.png)
`
      },
      {
        id: "006007",
        title: "律师查看运营数据",
        content: `
律师可以从我的名片-“智聊”中查看客户咨询的问题及回答，并识别是否存在潜在案源机会。也可以从“咨询”列表中查看客户发起的一对一人工咨询，并进行线上的沟通回复：

![image](https://delicdn.delilegal.com/dls/b6eeff8cc1944287db124e3d1aab06db/b6eeff8cc1944287db124e3d1aab06db.png)
`
      }
    ]
  },
  {
    id: "005",
    title: "其他问题",
    children: [
      {
        id: "005001",
        title: "如何修改账号绑定的手机号？",
        content: `
第一步：点击链接进入个人信息中的安全设置<a style="color:#4493f8" href="https://data.delilegal.com/account/base">https://data.delilegal.com/account/base</a>

并点击更换手机

![image](https://delicdn.delilegal.com/dls/fe47bf422312152dd0f009ff2f94d3f0/fe47bf422312152dd0f009ff2f94d3f0.png)

第二步：通过手机验证，更换为新的手机号

![image](https://delicdn.delilegal.com/dls/538769943c5b04088de804c8a837252e/538769943c5b04088de804c8a837252e.png)
        `
      },
      {
        id: "005002",
        title: "得理科技如何保障数据的安全性？",
        content: `
首先是存储安全性，我们采用阿里云存储服务，遵循行业标准，其内在的异地灾备和多线机制能确保数据的存放安全。

其次是高可用性，我们采用了容器化的可伸缩架构，通过技术手段使平台在高并发时仍然能够提供服务而不会超时或拥堵。

另外是数据保密性，我们对敏感信息采取了加密存储和传输，确保敏感数据安全，同时我们坚持贯彻按ISO27001信息安全管理体系开展研发工作，提升信息安全的管理级别。
        `
      },
      {
        id: "005003",
        title: "购买得理产品的订单可以开发票吗？",
        content: `
可以的，付费后可以从“我的”->“订单及续费管理”找到付费的订单，并点击该订单的“开发票”就可以提交开票申请，得理财务人员收到请求后通常在3个工作日内开出电子发票并短信通知用户，用户可以在订单处查看并下载电子发票。
        `
      },
      {
        id: "005004",
        title: "得理法律大模型与通用模型有什么区别和优势呢？",
        content: `
得理法律大模型（小理AI） 的本质是一个 “专精型”的法律行业解决方案。它通过 “专业数据 + 领域微调 + RAG增强” 的技术路径，构建了在准确性、时效性、可靠性上远超通用模型的核心优势，旨在直接提升法律工作的效率与质量，输出可信、可用的专业成果。

通用大模型（如DeepSeek） 的本质是一个 “泛化型”的基础智能引擎。其在复杂逻辑推理、思维发散、跨领域知识联想方面具有优势，能为法律人提供宝贵的思路启发和初步框架。但在处理需要高度精确性、实时性和专业性的法律任务时，存在幻觉风险高、专业深度不足、结果不可直接信赖的明显短板。

对于追求结果可靠、交付即用的法律专业人士，得理法律大模型是更高效、更安全的生产力工具。
        `
      },
      {
        id: "005005",
        title: "如何要求得理打码案件中的实名信息？",
        content: `
得理法搜中的裁判文书为最高院裁判文书网中公开对应文件，如发现文书中对于当事人名称和地址有需要打码或隐藏时，请添加得理科技企业微信客户进行反馈，我们将尽快为您处理。
        `
      },
      {
        id: "005006",
        title: "什么是邀请码，如何获取邀请码？",
        content: `
邀请码是得理科技在开展一些不定期活动（加企微送免费体验等福利）时提供给到用户的一个活动邀请数字序列（4位数字），用户在“我的”->“会员邀请码”，输入客服给到的邀请码，就可以延长免费使用的期限。详情请添加得理科技企业微信客服了解。
        `
      },
      {
        id: "005007",
        title: "得理产品能力支持API调用吗？",
        content: `
支持API调用，目前得理科技支持得理法律大模型和法律数据检索支持接口调用，可点击链接注册为开发者了解并进行调用<a style="color:#4493f8" href="https://open.delilegal.com/">https://open.delilegal.com/</a>
        `
      },
      {
        id: "005008",
        title: "API调用是如何收费的？",
        content: `
得理法搜大模型和法律数据检索的收费价格见下图：

![image](https://delicdn.delilegal.com/dls/964aee07e12ea2d32ebe4a84f8a34411/964aee07e12ea2d32ebe4a84f8a34411.png)
        `
      },
    ]
  }
];
